import {action, makeAutoObservable, observable} from "mobx";
import CommonStore from "../../../stores/CommonStore";
import { SalePriceService } from "../../../service/SalePriceService";

class ShowEditTopupSalePriceStore {

    public salePriceId: string;
    public productId: string;
    public value: number;
    public isModalOpen: boolean;
    public loading: boolean;
    public commonStore: CommonStore;


    constructor(commonStore: CommonStore, salePriceId: string, productId: string, value: number) {
        this.loading = false;
        this.commonStore = commonStore;
        this.salePriceId = salePriceId;
        this.productId = productId;
        this.value = value;
        this.isModalOpen = false;
        makeAutoObservable(this, {
            isModalOpen: observable
        });
    }

    @action
    public openModal(): void {
        this.isModalOpen = true;
    }

    @action
    public closeModal() {
        this.isModalOpen = false;
    }

    @action
    public async updateTopupSalePrice() {
        const response = await SalePriceService.updateTopupSalePrice(this.salePriceId, this.productId, this.value);
        this.commonStore.processErrors(response);
        return response.success;
    }
}

export default ShowEditTopupSalePriceStore;